import React from 'react'

import { Text } from '@interco/inter-toranja'

import type { ToranjaTextSize, ToranjaTextType, ToranjaTextWeight } from '../interfaces'

interface TextProps {
  text?: string
  textSize?: ToranjaTextSize
  textType?: ToranjaTextType
  textWeight?: ToranjaTextWeight
  typeElement?: 'p' | 'span' | 'strong'
}

export const TextComponent: React.FC<TextProps> = ({
  text,
  textSize = 'medium',
  textType = 'display',
  textWeight = 'regular',
  typeElement = 'span',
}) => (
  <Text textSize={textSize} textType={textType} textWeight={textWeight} as={typeElement}>
    {text}
  </Text>
)
